/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7d170b3fdf32ca9dd11fbb9bb1f72d59>>
 * @codegenCommand yarn build:icon-glyphs
 */
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _baseNew = _interopRequireDefault(require("@atlaskit/icon/base-new"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Icon: "CloudSaved".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for showing saved status after successful cloud synchronisation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */
const CloudSavedIcon = props => /*#__PURE__*/_react.default.createElement(_baseNew.default, Object.assign({
  dangerouslySetGlyph: `<path fill="currentcolor" d="M8 1.5c1.251 0 2.409.4 3.353 1.078l-1.026 1.115a4.25 4.25 0 0 0-6.563 3.208.75.75 0 0 1-.565.667A2.251 2.251 0 0 0 3.75 12H12a2.5 2.5 0 0 0 1.174-4.708L14.2 6.16A4 4 0 0 1 12 13.5H3.75a3.75 3.75 0 0 1-1.418-7.222A5.75 5.75 0 0 1 8 1.5"/><path fill="currentcolor" d="m8.982 9.993 4.583-5.25-1.13-.986-4.016 4.6L6.817 6.51l-1.134.982 2.167 2.5a.75.75 0 0 0 1.132.002"/>`
  // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
}, props));
CloudSavedIcon.displayName = 'CloudSavedIcon';
var _default = exports.default = CloudSavedIcon;